/**
 * Returns headerProps for axp-page-wrapper that redirects the user to the
 * current page (instead of their dashbaord, the default behavior) after
 * clicking Login/Logout on global header / iNav
 * @returns {Object} Returns headerProps for axp-page-wrapper.
 */

function getGlobalHeaderProps() {
  if (global.BROWSER) {
    const destPage = window.location.href;
    return {
      loginDestPage: destPage,
      logoutDestPage: destPage,
    };
  }
  return null;
}

export default getGlobalHeaderProps;
